<template>
    <div id="dingzi">
        <div class="box" >
            <h1>抢先体验 <span>每人仅限一次</span></h1>
            <p>3元/1小时无限畅读</p>
            <div class="btn" @click="active = 46;show=true;">
                立即<br>体验
            </div>
        </div>
        <div class="box">
            <h1>尊享福利 <span>每个用户仅限一次</span></h1>
            <p>365元/全年无限畅读万本全库书籍<br>现在开通全年畅读，即可立省千元！</p>
            <div class="btn" @click="active = 1;show=true;">
                立即<br>体验
            </div>
        </div>
        <div class="tip">
            <h6>活动规则：</h6>
            <p>1.此充值为开通年费服务;</p>
            <p> 2.年费服务为虚拟充值，一经购买不支持退货;</p>
            <p> 3.活动最终解释权归网站所有;</p>
        </div>

        <div class="type" v-if="show" @click="show=false">
            <ul>
                <li class="wechat" :class="{active:type == 6}" @click="setType(6)">
                    <img src="http://static.yuread.cn/quick/wechat1.png" alt=""> 微信充值
                </li>
                <li class="zfb" :class="{active:type == 7}" @click="setType(7)">
                    <img src="http://static.yuread.cn/quick/zfb1.png" alt=""> 支付宝
                </li>
            </ul>
        </div>

    </div>
</template>

<script>
    export default {
        name: "Dingzi",
        data(){
            return {
                type : 6,
                show : false,
                active : 1,

            }
        },
        methods : {
            setType(type){
                this.type = type;
                system.postMessage(JSON.stringify({
                    active : this.active,
                    type : this.type
                }))
            }
        }
    }
</script>

<style lang="less">
    #dingzi{padding:800px 40px 40px 40px;min-height:100%;background-color:#f54742;background-image: url("http://static.yuread.cn/quick/dingzi.png");background-size:100% ;background-repeat:no-repeat;overflow: auto;
        .box{width: 100%;background-color: #fff;border-radius: 42px;padding:40px;position:relative;margin-bottom: 32px;
            h1{color: #f64841;font-size: 48px;margin-bottom: 20px;
                span{font-size: 20px;color: #f64841;font-weight: 400}
            }
            p{font-size: 24px;color: #f64841;font-weight: bold;

            }
            .btn{position:absolute;top:0;right:42px;padding:32px; color:#e44039;font-size:32px;font-weight:bold;width: 128px;height: 180px;border-radius: 0px 0px 200px 200px;background: linear-gradient(144deg, #FEEFC1 0%, #FCC886 59%, #FCC682 100%);box-shadow: 0px 4px 20px 0px #FDE1AB;}
        }
        .tip{margin-top: 50px;color: #fff;
            h6{font-size: 32px;}
            p{font-size: 28px;}
        }

        .type{
            background-color: rgba(0,0,0,.3);position: fixed;top:0;left:0;right:0;bottom:0;
            ul{ position:absolute;bottom:0;width: 100%;background-color: #fff;display: flex;justify-content: space-between;padding: 102px 40px 68px;border-radius: 58px 58px 0 0;
                li{width: 308px;height:86px;text-align: center;border-radius: 43px;color: #fff;font-size: 32px;line-height: 86px;}
                .wechat{background-color: #32BE1B;}
                .zfb{background-color: #1296db;}
                img{width: 34px;height:34px;position: relative;top:5px;}
            }
        }

    }
</style>
